import DashboardHeader from '../components/Navbar';
import DashboardSidebar from '../components/Sidebar';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useCheckLink } from '../Authentication/api/apiAuthentication';
import SuspenseLoader from '../components/suspenseLoader';


function RootLayout() {
    const token = sessionStorage.getItem("apayroucarayxczijiuhxvkdsp")


    const { data: checkIP, isLoading } = useCheckLink()
    const navigate = useNavigate()

    if (isLoading) {
        return (
            <SuspenseLoader />
        )
    }

    if (checkIP?.message === "Access denied. IP is blocked") {
        sessionStorage.removeItem('apayroucarayxczijiuhxvkdsp')
        sessionStorage.removeItem('theme-dark')
        navigate('/blocked')
    }


    else return (
        token ?
            <div className='ad_pg'>
                <DashboardHeader />
                <div className="ad_pg_bd">
                    <div className="container-fluid p-0">
                        <div className="row ad_bd_row g-0">
                            <div className="col-md-auto ad_pg_lt_spc-lg">
                                <DashboardSidebar />
                            </div>
                            <div className="col-md ad_pg_rt_spc-lg">
                                <div className="ad_pg_bd_inr">
                                    <Outlet />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            :
            <Navigate to='/' />
    )
}

export default RootLayout